<ol class="d-flex flex-wrap justify-content-center justify-content-md-start mb-0"
    data-automation-id="bookmarks-lists-list"
    [attr.aria-label]="'bookmarksListsListTitle' | translate">
  <li *ngFor="let list of lists; trackBy: trackById"
      class="d-block m-2 m-md-4"
      data-automation-id="bookmarks-list-card">
    <app-list-card [list]="list" (onListOpened)="openList(list)"></app-list-card>
  </li>
</ol>
